import type { FunctionComponentWithRef } from "react";

import { Icon, StyledButton } from "./styles";

type Props = {
  className?: string;
  onClick?: () => void;
};

export const ArticleCommentsIcon: FunctionComponentWithRef<Props, HTMLButtonElement> = ({
  className,
  onClick,
  ref,
}) => (
  <StyledButton className={className} onClick={onClick} ref={ref}>
    <Icon />
  </StyledButton>
);

ArticleCommentsIcon.displayName = "ArticleCommentsIcon";
